var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-09-13
 * @brief SEI 운영관리 -SiteInfoView 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { adminApprovalState, adminTypeState, alertState, curAdminTreeState, } from "../../../../../recoil/assessmentState";
import { reLoad, reLoadPage, userInfoLoginState } from "../../../../../recoil/userState";
// utils
import { langId } from "../../../../../recoil/langState";
import { loadingBoxState } from "../../../../../recoil/menuState";
import * as CONST from "../../../../../utils/Const";
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../../utils/commUtils";
import { useTrans } from "../../../../../utils/langs/useTrans";
import EhpPostCode from "../../../../common/postcode/EhpPostCode";
function SiteZone(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilApproval = useRecoilValue(adminApprovalState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [reload, setReload] = useRecoilState(reLoad);
    const setRecoilType = useSetRecoilState(adminTypeState);
    const langIds = useRecoilValue(langId);
    // props
    const { onClickTab, handleOpenPop, isMobile } = props;
    const [zoneInfo, setZoneInfo] = useState(null);
    const [zoneItem, setZoneItem] = useState(null);
    const [zoneAddress, setZoneAddress] = useState(null);
    const [isPopupPostCode, setIsPopupPostCode] = useState(false);
    const [resetPop, setResetPop] = useState(false);
    const [editPop, setEditPop] = useState(false);
    useEffect(() => {
        handleOpenPop("pop-memo2", _jsx(MemoPop, { htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.반려") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-memo2") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        handleOpenPop("pop-cancel2", _jsx(CancelPop, {}));
    }, []);
    useEffect(() => {
        // 등록
        handleOpenPop("pop-add-detail", _jsx(SubZoneAddpop, { zoneAddress: zoneAddress, setIsPopupPostCode: setIsPopupPostCode, setZoneAddress: setZoneAddress, resetPop: resetPop, setResetPop: setResetPop, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.신규추가") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-add-detail") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        handleOpenPop("pop-add-detail-edit", _jsx(ZoneEditPop, { setIsPopupPostCode: setIsPopupPostCode, zoneAddress: zoneAddress, setZoneAddress: setZoneAddress, zoneItem: zoneItem, editPop: editPop, setEditPop: setEditPop, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.수정") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-add-company") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        //
        handleOpenPop("pop-postcode", _jsx(EhpPostCode, { isPopup: isPopupPostCode, setIsPopup: setIsPopupPostCode, setAddress: callbackSetZoneInfoAddress }));
        // 삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, {}));
    }, [zoneAddress, resetPop, zoneAddress, editPop, zoneItem, isPopupPostCode]);
    function Close(id) {
        if (id == "pop-add-detail") {
            setResetPop(true);
        }
        else {
            setEditPop(true);
        }
        CUTIL.jsclose_Popup(id);
    }
    // 기본 주소
    let appPath = `?zoneId=${recoilTree.zone.zoneId}`;
    // 사업장 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/zone/detail${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setZoneInfo(data.body);
                if (reload) {
                    setReload(false);
                }
            }
        }
    }, [data, reload, langIds]);
    function EditPop(e) {
        setZoneItem(zoneInfo);
        setZoneAddress(Object.assign(Object.assign({}, zoneAddress), { address: zoneInfo.address }));
        CUTIL.jsopen_Popup(e);
    }
    function callbackSetZoneInfoAddress(val) {
        setZoneAddress(val);
    }
    function SubZoneGo(item) {
        setRecoilTree(Object.assign(Object.assign({}, recoilTree), { subZone: {
                subZoneId: item.subZoneId,
                subZoneName: item.subZoneName,
            } }));
        setRecoilType("subZone");
        onClickTab("DEVICE");
        let zone_class = document.querySelector(".add");
        zone_class.classList.add("nobg");
        if (recoilTree.room.roomId) {
            let subzone_class = document.querySelector(".szadd");
            subzone_class.classList.remove("nobg");
        }
    }
    return (_jsx(_Fragment, { children: zoneInfo && (_jsxs("div", Object.assign({ className: "box__body", style: { paddingTop: isMobile ? "59px" : "24px" } }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: (userInfo.role == CONST.USERROLE_SUPER || userInfo.role == CONST.USERROLE_ADMIN) && (_jsxs("div", Object.assign({ className: "top-button" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn btn-edit blue js-open", "data-pop": "pop-add-detail-edit", onClick: (e) => EditPop(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete blue js-open", "data-pop": "pop-delete", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }))) })) })), _jsxs("div", Object.assign({ className: "content__info" }, { children: [_jsx("h3", Object.assign({ className: "hide" }, { children: "\uC0AC\uC5C5\uC7A5\uC815\uBCF4" })), _jsxs("ul", Object.assign({ className: "form__info" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.회사명") })), _jsxs("p", Object.assign({ className: "txt" }, { children: [recoilTree.company.companyName, recoilApproval.approval == 0 ? (_jsxs("span", Object.assign({ className: `request-cond js-open ok`, "data-pop": "pop-memo2", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: [_jsx("span", { children: t("라벨.요청반려") }), _jsx("span", Object.assign({ className: "tit" }, { children: t("라벨.확인") }))] }))) : recoilApproval.approval == 1 ? (_jsxs("span", Object.assign({ className: `request-cond js-open `, "data-pop": "pop-cancel2", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: [_jsx("span", { children: t("라벨.추가요청중") }), _jsx("span", Object.assign({ className: "tit" }, { children: t("라벨.취소") }))] }))) : recoilApproval.approval == 4 ? (_jsxs("span", Object.assign({ className: `request-cond js-open ok` }, { children: [" ", _jsx("span", { children: t("라벨.삭제요청중") }), _jsx("span", Object.assign({ className: "tit " }, { children: t("라벨.확인") }))] }))) : (recoilApproval.approval == 5 && (_jsxs("span", Object.assign({ className: `request-cond js-open ok` }, { children: [" ", _jsx("span", { children: t("라벨.삭제반려") }), _jsx("span", Object.assign({ className: "tit" }, { children: t("라벨.확인") }))] }))))] }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit w120" }, { children: [" ", t("라벨.사업장명")] })), _jsx("p", Object.assign({ className: "txt" }, { children: zoneInfo.zoneName }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.사업장주소") })), _jsx("p", Object.assign({ className: "txt" }, { children: zoneInfo.address }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w120" }, { children: t("라벨.메모") })), _jsx("p", Object.assign({ className: "txt" }, { children: !zoneInfo.memo ? "-" : zoneInfo.memo }))] })] }))] })), _jsxs("div", Object.assign({ className: "content__info line" }, { children: [recoilApproval.approval == 2 && (_jsx("div", Object.assign({ className: "top" }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.상세사업장현황") })) }))), recoilApproval.approval == 2 && (_jsxs("ul", Object.assign({ className: "box-small-wrap link" }, { children: [zoneInfo.subZoneManageList.map((item, idx) => (_jsxs("li", Object.assign({ onClick: (e) => SubZoneGo(item), style: { cursor: "pointer" } }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: item.subZoneName })), _jsx("p", Object.assign({ className: "count-info" }, { children: _jsxs("span", { children: [_jsx("strong", { children: item.itemCount }), "ea"] }) }))] }), "subZoneManageList_" + idx.toString()))), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add js-open", "data-pop": "pop-add-detail", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.상세사업장추가") })) })) })] })))] }))] }))) }));
}
export default SiteZone;
function SubZoneAddpop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    //props
    const { zoneAddress, setIsPopupPostCode, resetPop, setResetPop, setZoneAddress } = props;
    const [errorList, setErrorList] = useState([]);
    const [subZoneName, setSubZoenName] = useState("");
    const [memo, setMemo] = useState("");
    useEffect(() => {
        if (resetPop) {
            Close("pop-add-detail");
        }
    }, [resetPop]);
    function onChangeSubZone(e) {
        setErrorList(errorList.filter((err) => err.field !== "subZoneName"));
        setSubZoenName(e.target.value);
    }
    function SubZoneAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            // if ((zoneAddress && zoneAddress.address) && subZoneName) {
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/product/subzone`,
                appQuery: {
                    zoneId: recoilTree.zone.zoneId,
                    subZoneName: subZoneName,
                    memo: memo,
                    addressDtoIn: {
                        address: zoneAddress ? zoneAddress.address : null,
                        sigunguCd: zoneAddress ? zoneAddress.sigunguCd : null,
                        bjdongCd: zoneAddress ? zoneAddress.bjdongCd : null,
                        bun: zoneAddress ? zoneAddress.bun : null,
                        ji: zoneAddress ? zoneAddress.ji : null,
                        postalCode: zoneAddress ? zoneAddress.postalCode : null,
                        bname: zoneAddress ? zoneAddress.bname : null,
                    },
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    Close("pop-add-detail");
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.상세사업장이등록되었습니다"), callBack: () => {
                            setReloadPages(true);
                            setReload(true);
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    if (data.errorList !== null) {
                        setErrorList(data.errorList);
                    }
                    else {
                        Close("pop-add-detail");
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "500 Internal Server Error", callBack: () => {
                                CUTIL.jsclose_Popup(CONST.POP_ALERT);
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
            /*  } else {
               setErrorList([
                 (!subZoneName) && { field: "subZoneName", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                 (!zoneAddress) && { field: "address", msg: t("라벨.필수항목을입력하지않으셨습니다") },
               ])
         
             } */
        });
    }
    function SubZoneAddress(subZoneId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/energyreport/address`,
                appQuery: {
                    address: zoneAddress.address,
                    sigunguCd: zoneAddress.sigunguCd,
                    bjdongCd: zoneAddress.bjdongCd,
                    bun: zoneAddress.bun,
                    ji: zoneAddress.ji,
                    postalCode: zoneAddress.postalCode,
                    bname: zoneAddress.bname,
                    subZoneId: subZoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPages(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.상세사업장이등록되었습니다") }));
                    Close("pop-add-detail");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReloadPages(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setErrorList(data.errorList);
                    setReloadPages(true);
                    setReload(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-add-detail", type: CONST.TYPE_ERROR, divTag: t("라벨.상세사업장의주소를다시입력해주세요") }));
                    Close("pop-add-detail");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReloadPages(false);
                    setRecoilIsLoadingBox(false);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    function onClickPostCode(e) {
        setIsPopupPostCode(true);
        CUTIL.jsopen_InteriorPopup(e);
    }
    function Close(id) {
        CUTIL.jsclose_Popup(id);
        setErrorList([]);
        setSubZoenName("");
        setMemo("");
        setZoneAddress(null);
        setResetPop(false);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("ul", Object.assign({ className: "locate" }, { children: _jsx("li", { children: recoilTree.zone.zoneName }) })), _jsx("h2", Object.assign({ className: "mt-32" }, { children: t("라벨.신규상세사업장정보") })), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.명칭") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "subZoneName").length > 0 ? " input-error" : ""}`, type: "text", value: subZoneName, placeholder: t("라벨.상세사업장입력"), onChange: (e) => onChangeSubZone(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "subZoneName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.상세사업장주소") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "txt" }, { children: [_jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { className: `js-open ${errorList.filter((err) => err.field === "address").length > 0 ? " input-error" : ""}`, type: "text", style: { background: "#fff" }, "data-pop": "pop-postcode", onFocus: (e) => onClickPostCode(e), placeholder: t("라벨.주소선택"), value: zoneAddress ? zoneAddress.address : "", readOnly: true }), _jsx("button", Object.assign({ type: "button", className: "btn btn-search js-open", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "address").map((err) => err.msg) }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-add-detail") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SubZoneAdd(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function ZoneEditPop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    //props
    const { zoneAddress, setIsPopupPostCode, editPop, setEditPop, zoneItem } = props;
    const [zoneName, setZoneName] = useState("");
    const [memo, setMemo] = useState("");
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        if (zoneItem) {
            setZoneName(zoneItem.zoneName);
            setMemo(zoneItem.memo);
        }
        if (editPop) {
            Close("pop-add-detail-edit");
        }
        setErrorList([]);
    }, [zoneItem, editPop]);
    function onChangeZoneName(e) {
        setErrorList(errorList.filter((err) => err.field !== "zoneName"));
        setZoneName(e.target.value);
    }
    function onClickPostCode(e) {
        setErrorList(errorList.filter((err) => err.field !== "adress"));
        setIsPopupPostCode(true);
        CUTIL.jsopen_InteriorPopup(e);
    }
    function ZoneUpdate(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/zone/${recoilTree.zone.zoneId}`,
                appQuery: {
                    zoneName: zoneName,
                    address: zoneAddress.address ? zoneAddress.address : "",
                    memo: memo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRecoilTree(Object.assign(Object.assign({}, recoilTree), { zone: { zoneId: data.body.zoneId, zoneName: data.body.zoneName } }));
                    setReload(true);
                    setReloadPages(true);
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.수정되었습니다") }));
                    Close("pop-add-detail-edit");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadPages(false);
                    setReload(false);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    function Close(id) {
        setZoneName(zoneItem.zoneName);
        setMemo(zoneItem.memo);
        setEditPop(false);
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("h2", { children: t("라벨.신규사업장정보") }), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.사업장명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.사업장명입력"), className: `${errorList.filter((err) => err.field === "zoneName").length > 0 ? " input-error" : ""}`, value: zoneName, onChange: (e) => onChangeZoneName(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "zoneName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.사업장주소") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("div", Object.assign({ className: "txt" }, { children: _jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "address").length > 0 ? " input-error" : ""}`, type: "text", style: { background: "#fff" }, placeholder: t("라벨.직접입력"), value: zoneAddress ? zoneAddress.address : "", readOnly: true }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "address").map((err) => err.msg) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-search js-open", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })) })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", placeholder: t("라벨.텍스트입력"), value: memo || "", onChange: (e) => setMemo(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-add-detail-edit") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => ZoneUpdate(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeletePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const setReload = useSetRecoilState(reLoad);
    const [alert, setAlert] = useRecoilState(alertState);
    function Delete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/product/zone/${recoilTree.zone.zoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-delete");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsclose_Popup("pop-delete");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("p", { children: [t("라벨.사업장을삭제하시겠습니까"), "?"] }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => {
                            Delete(e);
                        } }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function MemoPop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilApproval, setrecoilApproval] = useRecoilState(adminApprovalState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [checked, setChecked] = useState(true);
    function onChangeChecked(e) {
        if (checked) {
            setChecked(false);
        }
        else {
            setChecked(true);
        }
    }
    function Delete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            if (recoilApproval.approval > 4) {
                CUTIL.jsclose_Popup("pop-memo2");
            }
            else {
                if (checked) {
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "DELETE",
                        appPath: `/product/usertree?productId=${recoilTree.zone.zoneId}`,
                        appQuery: {},
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        if (data.codeNum == CONST.API_200) {
                            CUTIL.jsclose_Popup("pop-memo2");
                            setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.삭제되었습니다") }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                            setChecked(true);
                        }
                        else {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                            CUTIL.jsclose_Popup("pop-memo2");
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                }
                else {
                    CUTIL.jsclose_Popup("pop-memo2");
                    setChecked(true);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.반려사유") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h142", readOnly: true, value: recoilApproval ? recoilApproval.deniedReason : "" }), recoilApproval.approval <= 4 && (_jsxs("div", Object.assign({ className: "mt-8" }, { children: [_jsx("input", { type: "checkbox", id: "t_1", checked: checked ? true : false, onChange: (e) => onChangeChecked(e) }), _jsxs("label", Object.assign({ htmlFor: "t_1", className: "w-auto" }, { children: [" ", t("라벨.사업장추가요청을취소합니다")] }))] })))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-memo2") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => Delete(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function CancelPop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReloadPages = useSetRecoilState(reLoadPage);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    // 엔지니어 승인 API
    function ApprovalCancel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/product/usertree?productId=${recoilTree.zone.zoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPages(true);
                    CUTIL.jsclose_Popup("pop-cancel2");
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.삭제되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReloadPages(false);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsclose_Popup("pop-cancel2");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.요청을취소하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-cancel2") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => ApprovalCancel(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
